import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

/**
 * Numbered section opener, matching the "01 / Per-block calls" pattern on
 * aerveil.ai. `dark` switches the palette for sections on the night ground.
 */
const SectionHeading = ({ number, label, title, intro, dark = false, align = 'left' }) => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-calm ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      } ${align === 'center' ? 'text-center' : ''}`}
    >
      <div
        className={`flex items-baseline gap-3 ${
          align === 'center' ? 'justify-center' : ''
        }`}
      >
        <span className={dark ? 'font-mono text-[0.7rem] tracking-eyebrow text-amber-bright' : 'section-num'}>
          {number}
        </span>
        <span
          className={`eyebrow ${dark ? 'text-cream/45' : 'text-ink-soft'}`}
        >
          {label}
        </span>
      </div>

      <h2
        className={`display-lg mt-5 ${dark ? 'text-cream' : 'text-ink'}`}
      >
        {title}
      </h2>

      {intro && (
        <p
          className={`lede mt-5 ${dark ? 'text-cream/70' : 'text-ink-muted'} ${
            align === 'center' ? 'mx-auto' : ''
          }`}
        >
          {intro}
        </p>
      )}

      <div className={`mt-10 ${dark ? 'rule-cream' : 'rule'}`} />
    </div>
  );
};

export default SectionHeading;
